import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { listRoute } from "./thunks/list-route";
import { startRoute } from "./thunks/start-route";

const name = "deliveries";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listRoute.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listRoute.fulfilled, (state, action) => {
        state.deliveries = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listRoute.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(startRoute.fulfilled, (state, action) => {
        // Optimistically advance the started delivery so the card flips to
        // "Registrar entrega" without a refetch.
        const started = state.deliveries.find(
          (d) => d.requestId === action.meta.arg.requestId,
        );
        if (started) started.state = "in_route";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
